import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_client = _resolveComponent("select-client")!
  const _component_posts_toolbar = _resolveComponent("posts-toolbar")!

  return (_openBlock(), _createBlock(_component_posts_toolbar, {
    filters: _ctx.filters,
    minimized: _ctx.minimized,
    "maximize-btn": _ctx.maximizeBtn,
    "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:filters', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_select_client, {
        "account-id": _ctx.accountId,
        "model-value": _ctx.clientId,
        style: {"min-width":"300px"},
        filled: "",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:clientId', $event)))
      }, null, 8, ["account-id", "model-value"])
    ]),
    _: 1
  }, 8, ["filters", "minimized", "maximize-btn"]))
}